export function normalizePaginatedResponse(
  payload,
  page = 1,
  pageSize = 20,
  sortBy = 'full_name',
  sortOrder = 'asc',
  search = '',
  role = ''
) {
  if (Array.isArray(payload)) {
    // Optional client-side search/filter when server doesn't support
    let rows = payload;
    const term = (search || '').toString().trim().toLowerCase();
    if (term) {
      rows = rows.filter((u) => {
        const n = (u.full_name || '').toLowerCase();
        const e = (u.email || '').toLowerCase();
        const p = (u.phone_number || '').toLowerCase();
        return n.includes(term) || e.includes(term) || p.includes(term);
      });
    }
    if (role) {
      rows = rows.filter((u) => u.role === role);
    }

    // Optional client-side sort
    const key = sortBy || 'full_name';
    const order = (sortOrder || 'asc').toLowerCase() === 'desc' ? -1 : 1;
    const getVal = (u) => {
      if (key === 'email') return (u.email || '').toLowerCase();
      if (key === 'created_at') return u.created_at || '';
      return (u.full_name || '').toLowerCase();
    };
    rows = [...rows].sort((a, b) => {
      const av = getVal(a);
      const bv = getVal(b);
      if (av < bv) return -1 * order;
      if (av > bv) return 1 * order;
      return 0;
    });

    const total = rows.length;
    const pages = Math.max(1, Math.ceil(total / Math.max(1, pageSize)));
    const currentPage = Math.min(Math.max(1, page), pages);
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    const items = rows.slice(start, end);
    return {
      items,
      total,
      page: currentPage,
      page_size: pageSize,
      pages,
      has_next: currentPage < pages,
      has_prev: currentPage > 1,
    };
  }
  // Envelope from server
  const total = payload?.total ?? 0;
  const pages = payload?.pages ?? Math.max(1, Math.ceil(total / Math.max(1, payload?.page_size ?? pageSize)));
  return {
    items: payload?.items ?? [],
    total,
    page: payload?.page ?? page,
    page_size: payload?.page_size ?? pageSize,
    pages,
    has_next: Boolean(payload?.has_next ?? ((payload?.page ?? page) < pages)),
    has_prev: Boolean(payload?.has_prev ?? ((payload?.page ?? page) > 1)),
  };
}
